import axios from "axios";
import { useState } from "react";
import { BaseUrlServ } from "../../../services/axios/AxiosEndpoints";
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
} from "@mui/material";
import Swal from "sweetalert2";
import DOMPurify from "dompurify";

const GetNucleoFamiliar = () => {
  /* ---------------------- Datos del endpoint ---------------------- */

  /* Variable que almacena los datos del nucleo familar */
  const [dataNucleo, setDataNucleo] = useState();
  /* Variable que almacena los mensajes de errores  */
  const [ErrorNucleo, setErrorNucleo] = useState();
  /* Variable que almacena el codigo de estado */
  const [StateNucleo, setStateNucleo] = useState();
  /* Variable que almacena el estado de la peticion */
  const [isFetching, setIsFetching] = useState(true);
  /* Checked para seleccionar la poliza*/
  const [checked, setChecked] = useState(false);
  /* Checked para seleccionar la poliza*/
  const [checkedPoliza, setCheckedPoliza] = useState(true);
  /* Checked para seleccionar la  cedula */
  const [checkedCedula, setCheckedCedula] = useState(false);
  /* Codigo del afiliado */
  const [codigoAfil, setCodigoAfil] = useState();

  /* ---------------------- Estilos de la tabla ---------------------- */

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#46cffa",
      color: "#fff",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  /* ---------------------- Datos de la tabla ---------------------- */

  const columns = [
    { id: "codigo", label: "Código", Width: "auto" },
    { id: "nombre", label: "Nombre", Width: "auto" },
    { id: "estado", label: "Estado", Width: "auto" },
    { id: "parentesco", label: "Parentesco", Width: "auto" },
  ];

  /* ---------------------- Paginacion de la tabla ---------------------- */

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  /* ------------------------------------------------------------------------------------- */

  const HandleChangeCedula = (e) => {
    // Obtén el valor actual del campo de identificación
    let { value } = e.target;

    // Elimina los guiones existentes, si los hay
    value = value.replace(/-/g, "");

    // Agrega guiones en las posiciones correctas
    if (value.length > 2 && value.length <= 11) {
      value = `${value.slice(0, 3)}-${value.slice(3, 10)}-${value.slice(10)}`;
    }

    // Actualiza el estado con el nuevo valor formateado
    setCodigoAfil(value);
  };

  /* ------------------------------------------------------------------------------------- */

  const HandleChangePoliza = (e) => {
    // Obtén el valor actual del campo de identificación
    let { value } = e.target;

    // Elimina los guiones existentes, si los hay
    value = value.replace(/-/g, "");

    // Agrega guiones en las posiciones correctas
    if (value.length > 5 && value.length <= 12) {
      value = `${value.slice(0, 5)}-${value.slice(5, 10)}-${value.slice(10)}`;
    }

    // Actualiza el estado con el nuevo valor formateado
    setCodigoAfil(value);
  };

  /* ------------------------------------------------------------------------------------- */

  const HandleChangeFunction = () => {
    setChecked(!checked);

    if (!checked) {
      setChecked(true);
      setCheckedPoliza(false);
      setCheckedCedula(true);

      const inputDOM = document.getElementById("plastico");
      inputDOM.value = "";

      setCodigoAfil("");
    } else {
      setChecked(false);
      setCheckedCedula(false);
      setCheckedPoliza(true);

      const inputDOM = document.getElementById("plastico");
      inputDOM.value = "";

      setCodigoAfil("");
    }
  };

  /* ---------------------- Obtener el codigo del afiliado ---------------------- */

  const HandleSubmitObtenerNucleo = async (e) => {
    e.preventDefault();

    const sanitizedCodigoAfiliad = DOMPurify.sanitize(codigoAfil);

    await axios({
      url: `${BaseUrlServ}/ObtenerNucleoFamiliar`,
      method: "POST",
      headers: {
        Accept: "*/*",
      },
      params: {
        identificacion: sanitizedCodigoAfiliad,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          const { value } = response.data;
          setDataNucleo(value);
          setStateNucleo(response.status);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400) {
            setErrorNucleo("El recurso no fue encontrado.");
          } else if (error.response.status === 500) {
            setErrorNucleo("Ha ocurrido un error en el servidor");
          }

          Swal.fire({
            title: "",
            text: "¡Ocurrió algo inesperado!",
            icon: "error",
            confirmButtonText: "Ok",
          });
        } else if (error.request) {
        }
      })
      .finally(() => setIsFetching(false));
  };

  /* ------------------------------------------------------------------------------------- */

  return (
    <Container maxWidth="lx">
      <Typography
        sx={{
          marginTop: "40px",
          marginBottom: "40px",
          fontSize: { xs: 22, sm: 22, md: 30, lg: 30 },
          textAlign: "center",
          fontWeight: 500,
        }}
      >
        NÚCLEO FAMILIAR
      </Typography>

      <Box
        component="form"
        maxWidth="lx"
        noValidate
        onSubmit={HandleSubmitObtenerNucleo}
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "40px",
          marginBottom: "20px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
            },
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            htmlFor="plastico"
            sx={{
              textAlign: "start",
              fontWeight: 500,
              fontSize: 16,
              mb: 0,
            }}
          >
            <Checkbox
              checked={checkedCedula}
              onChange={(e) => HandleChangeFunction(e)}
              inputProps={{ "aria-label": "controlled" }}
            />
            CÉDULA
          </Typography>

          <Typography
            htmlFor="plastico"
            sx={{
              textAlign: "start",
              fontWeight: 500,
              fontSize: 16,
              mb: 0,
            }}
          >
            <Checkbox
              checked={checkedPoliza}
              onChange={(e) => HandleChangeFunction(e)}
              inputProps={{ "aria-label": "controlled" }}
            />
            PÓLIZA
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
            },
            justifyContent: "center",
            margin: 0,
            padding: 0,
            left: 0,
          }}
        >
          <Typography
            sx={{
              marginTop: "0px",
              marginBottom: "0px",
              marginRight: "20px",
              marginLeft: "0px",
              fontSize: { xs: 16, sm: 16, md: 22, lg: 22 },
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            Identificación
          </Typography>

          {!checked ? (
            <Box
              sx={{
                width: "auto",
              }}
            >
              <TextField
                variant="outlined"
                size="small"
                type="text"
                id="plastico"
                name="plastico"
                placeholder="Identificación del afiliado"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="EJEMPLO: 
              POLIZA XXXXX-XXXXX-XX  
              CEDULA XXX-XXXXXXX-X"
                value={codigoAfil}
                onChange={HandleChangePoliza}
                inputProps={{
                  maxLength: 14,
                }}
                sx={{
                  width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" },
                  height: "auto",
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: "auto",
              }}
            >
              <TextField
                variant="outlined"
                size="small"
                type="text"
                id="plastico"
                name="plastico"
                placeholder="Identificación del afiliado"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="EJEMPLO: 
                POLIZA XXXXX-XXXXX-XX  
                CEDULA XXX-XXXXXXX-X"
                value={codigoAfil}
                onChange={HandleChangeCedula}
                inputProps={{
                  maxLength: 13,
                }}
                sx={{
                  width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" },
                  height: "auto",
                }}
              />
            </Box>
          )}
          <Box
            sx={{
              width: "auto",
              mt: 0,
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="success"
              sx={{
                left: { xs: "0px", sm: "0px", md: "20px", lg: "20px" },
                top: { xs: "15px", sm: "15px", md: "0px", lg: "0px" },
                fontSize: 16,
              }}
            >
              Validar
            </Button>
          </Box>
        </Box>
      </Box>

      {isFetching ? (
        <>
          <Paper sx={{ width: "100%", marginTop: "80px" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableRow>
                    {columns.map((column) => (
                      <StyledTableCell
                        key={column.id}
                        align={column.align}
                        style={{ width: column.Width }}
                      >
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell align="right">Registro Vacio</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </>
      ) : (
        <>
          <Paper sx={{ width: "100%", marginTop: "80px" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableRow>
                    {columns.map((column) => (
                      <StyledTableCell
                        key={column.id}
                        align={column.align}
                        style={{ width: column.Width }}
                      >
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {dataNucleo
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((dataNucleo) => {
                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={dataNucleo.code}
                        >
                          {columns.map((column) => {
                            const value = dataNucleo[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === "number"
                                  ? column.format(value)
                                  : value}
                              </TableCell>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={dataNucleo?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </>
      )}
    </Container>
  );
};

export default GetNucleoFamiliar;

/*

<Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "baseline",
            marginTop: "40px",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Identificación
          </Typography>

          <TextField
            sx={{
              mt: 0,
              mb: 0,
              mx: 2,
              width: {
                xs: "100%",
                sm: "100%",
                md: "20%",
                lg: "20%",
              },
              height: "10px",
            }}
            placeholder="Póliza o Cédula"
            autoComplete="codigoAfil"
            name="codigoAfil"
            size="small"
            value={codigoAfil}
            onChange={HandleCodigoAfiliado}
            helperText={validate().codigoAfil}
          />

          <Button
            type="submit"
            variant="contained"
            color="success"
            //onChange={HandlePasajeros}
            sx={{
              mt: 0,
              mb: 0,
              width: "auto",
            }}
          >
            Aceptar
          </Button>
        </Box>

*/
